// services/axiosInstance.ts
import axios from 'axios';
import { logout } from './auth.api';

const BASE_URL =  process.env.REACT_APP_LOGO_API_URL || ''

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

// Add token to every request (interceptor)
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Unauthorised error handling
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
       logout();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;